import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Form, Card, message, Input, Radio } from 'antd'
import ColorPicker from '@components/ColorPicker'
import UploadBase from '@components/UploadBase'
import api from '@services/api'
import { setConference, addConferenceTab } from '@store/actions'
import unit from '@/utils/utils'
const FormItem = Form.Item
import { useTranslation } from 'react-i18next'
const formItemLayout = {
  labelCol: {
    xs: {
      span: 4,
    },
    sm: {
      span: 4,
    },
  },
  wrapperCol: {
    xs: {
      span: 16,
    },
    sm: {
      span: 16,
    },
  },
}
interface ITabItem {
  tabName?: string
  icon?: string
  activeIcon?: string
  color?: string
  activeColor?: string
  tabId?: string
  tabUrl?: string
  text?: string
}
interface IConfigState {
  tabs: ITabItem[]
  color?: string
  activeColor?: string
  type?: 'text' | 'image'
}
interface IConferenceProps {
  config: IConfigState
  id: string
  domain?: string
  changeConference: (id, key, value, index) => void
  addTab: (id) => void
}

const mapStateToProps = state => ({
  domain: state.tree.root.config.domain,
})

const mapDisPatchToProps = dispatch => ({
  changeConference: (id, key, value, index) => {
    dispatch(setConference(id, key, value, index))
  },
  addTab: id => {
    dispatch(addConferenceTab(id))
  },
})
const uploadProps = {
  listType: 'picture-card',
  className: 'avatar-uploader',
  name: 'content',
  action: api.uploadImg,
  showUploadList: false,
  data: {
    format: 'jpg',
    fulldim: '300x300',
    path: 'a.jpg',
  },
  beforeUpload: file => {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJPG) {
      message.error('You can only upload JPG/PNG file!')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!')
    }
    uploadProps.data.path = `${unit.generateImgName()}${file.name}`
    return isJPG && isLt2M
  },
}

const ConferenceConfig: React.FC<IConferenceProps> = props => {
  const { config, changeConference, id, addTab } = props
  const { t } = useTranslation()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { color, activeColor, tabs } = config
  const [key, setKey] = useState('0')
  const currentValue = tabs && tabs[+key]
  useEffect(() => {
    if (!config.tabs) {
      changeConference(id, 'tabs', [{ tabName: 'tabName' }], '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const setValue = (name, value) => {
    changeConference(id, name, value, '')
  }
  const setTabItem = (name, value, index) => {
    changeConference(id, name, value, index)
  }
  const uploadImg = (e, name) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { domain } = props
    const basePath = api.baleenUrl
    if (e.file.status === 'done') {
      const imgPath = e.file.response.name
      setTabItem(name, `${basePath}/${imgPath}`, key)
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const content = (realColor, name) => (
    <ColorPicker handleOk={color => setValue(name, color)} color={realColor}></ColorPicker>
  )
  const tabList: any = tabs
    ? tabs.reduce((prev: any[], cur: ITabItem, index: number) => {
        prev.push({
          key: index.toString(),
          tab: cur.tabName || `tabBar${index}`,
        })
        return prev
      }, [])
    : []
  const onEdit = (targetKey, action: string) => {
    switch (action) {
      case 'add':
        addTab(id)
        setKey(tabs.length.toString())
        break
      case 'remove':
        let lastIndex
        tabList.forEach((pane, i) => {
          if (pane.key === targetKey) {
            lastIndex = i - 1
          }
        })
        if (lastIndex >= 0) {
          setKey(lastIndex)
        } else {
          setKey('0')
        }
        changeConference(id, '', '', targetKey)
        break
    }
  }
  return (
    <div className="conferenceContent">
      <Card
        style={{ width: '600px', marginTop: 30 }}
        tabList={tabList}
        activeTabKey={key}
        tabProps={{
          type: 'editable-card',
          onEdit: onEdit,
        }}
        onTabChange={key => {
          setKey(key)
        }}
      >
        <Form>
          <FormItem {...formItemLayout} label={t('conferenceType')}>
            <Radio.Group
              onChange={e => setValue('type', e.target.value)}
              value={config.type || 'image'}
            >
              <Radio value="image">{t('conferenceImage')}</Radio>
              <Radio value="text">{t('conferenceText')}</Radio>
            </Radio.Group>
          </FormItem>
          <FormItem {...formItemLayout} label="pageID">
            <Input
              className="input-lar-input"
              type="text"
              placeholder={t('conferencePageIDPlaceholder')}
              value={currentValue ? currentValue.tabId : ''}
              onChange={e => setTabItem('tabId', e.target.value, key)}
            />
          </FormItem>
          <FormItem {...formItemLayout} label={t('url')}>
            <Input
              className="input-lar-input"
              type="text"
              placeholder={t('conferenceUrlPlaceholder')}
              value={currentValue ? currentValue.tabUrl : ''}
              onChange={e => setTabItem('tabUrl', e.target.value, key)}
            />
            <a
              href={`${window.location.origin}${window.location.pathname}`}
              style={{ marginLeft: 10 }}
              target="_blank"
            >
              {t('findPages')}
            </a>
          </FormItem>
          {config.type === 'text' ? (
            <FormItem {...formItemLayout} label="text">
              <Input
                placeholder="text"
                value={currentValue ? currentValue.text : ''}
                onChange={e => {
                  setTabItem('text', e.target.value, key)
                }}
              ></Input>
            </FormItem>
          ) : (
            <>
              <FormItem {...formItemLayout} label={t('icon')}>
                <UploadBase
                  uploadProps={uploadProps}
                  value={currentValue && currentValue.icon}
                  onChange={e => uploadImg(e, 'icon')}
                ></UploadBase>
              </FormItem>
              <FormItem {...formItemLayout} label={t('activeIcon')}>
                <UploadBase
                  uploadProps={uploadProps}
                  value={currentValue && currentValue.activeIcon}
                  onChange={e => uploadImg(e, 'activeIcon')}
                ></UploadBase>
              </FormItem>
            </>
          )}
        </Form>
      </Card>
    </div>
  )
}

export default connect(mapStateToProps, mapDisPatchToProps)(ConferenceConfig)
